import { render } from "./GeneralInformation.vue?vue&type=template&id=5497d619&scoped=true&ts=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=ts"
export * from "./GeneralInformation.vue?vue&type=script&lang=ts"

import "./GeneralInformation.vue?vue&type=style&index=0&id=5497d619&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5497d619"]])

export default __exports__